'use client';
import { useEffect, useState } from 'react';
import _ from 'lodash'
import { usePathname } from 'next/navigation';
import { allTab } from '@/constants/common';

export function useTabsActive(curMode) {
    const [activeIndex, setActiveIndex] = useState(allTab[curMode][0].key);
    const pathName = usePathname();
    console.log(pathName)
    // const params = searchParams?.get('id');
    useEffect(() => {
        setActiveIndex(pathName);
    }, [pathName]);


    function changeActive(activePath: string) {
        setActiveIndex(activePath);
        location.href = activePath
    }

    return [activeIndex, changeActive];
}